module.exports = __webpack_public_path__ + "media/app/assets/specializations/monk/brewmaster-8c8e5bdacd329b1f378fb96b7fd2e30a.png";